const NotFoundRedirect = () => {
    window.location.href = 'https://www.vooxhub.com';
    return null;
};

export default NotFoundRedirect;
